import { useState, useEffect } from "react";
import { getPercentageUsage } from "../../utils/functions";

export default function UsagePercent({ doctor_id }) {
  const [usagePercentage, setUsagePercentage] = useState(null);

  useEffect(() => {
    (async () => {
      setUsagePercentage(await getPercentageUsage(doctor_id))
    })()
  }, [])

  return (
    <>
      {usagePercentage !== null ? (
        <>
          <span>{usagePercentage.toFixed(2)}%</span>
        </>
      ) : (
        <span className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple mx-auto"></span>
      )
      }
    </>
  )
}